import { camelCase } from "lodash";

import { SERVER_KEYS } from "./constants";

// The server counts weekdays from Monday as 0; the web counts from Sunday as 0.
const toServerDay = (day) => (day + 6) % 7;
const fromServerDay = (day) => (day + 1) % 7;

const DAY_CONVERSIONS = {
  weekStartsOn: { toServer: toServerDay, fromServer: fromServerDay },
  daysShown: {
    toServer: (days) => days.map(toServerDay).sort((a, b) => a - b),
    fromServer: (days) => days.map(fromServerDay),
  },
};

// Only the settings listed in `chosen` were saved; the rest are defaults the web works out itself.
// `chosen` holds the server's names, which the API layer does not camelCase.
export const savedFromServer = (data) => {
  const chosen = data?.chosen ?? [];
  return Object.fromEntries(
    Object.entries(SERVER_KEYS)
      .filter(([, serverKey]) => chosen.includes(serverKey))
      .map(([key, serverKey]) => {
        const value = data[camelCase(serverKey)];
        return [key, DAY_CONVERSIONS[key] ? DAY_CONVERSIONS[key].fromServer(value) : value];
      })
  );
};

export const valueToServer = (key, value) =>
  DAY_CONVERSIONS[key] ? DAY_CONVERSIONS[key].toServer(value) : value;
